import { ErrorBoundary } from '@shared/components';
import { links } from '@shared/utils';
import { RouteObject } from 'react-router-dom';

import { CheckoutLayout } from '../layout';
import { Data, Payment, Plans, Success, Summary } from '../pages';

export const CheckoutRoutesPublic = (): RouteObject[] => {
  return [
    {
      element: <CheckoutLayout />,
      children: [
        {
          path: links.checkout.main,
          element: <Plans />,
        },
        {
          path: links.checkout.plans,
          element: <Plans />,
        },
        {
          path: links.checkout.data,
          element: <Data />,
        },
        {
          path: links.checkout.payment,
          element: <Payment />,
        },
        {
          path: links.checkout.summary,
          element: <Summary />,
        },
        {
          path: links.checkout.success,
          element: <Success />,
        },
      ],
      errorElement: <ErrorBoundary />,
    },

    {
      path: '*',
      element: <CheckoutLayout />,
      children: [
        {
          path: '*',
          index: true,
          element: <Plans />,
        },
      ],
    },
  ];
};

export const PlansRoutesProtected: RouteObject[] = [
  {
    element: <CheckoutLayout />,
    children: [
      {
        path: links.checkout.main,
        element: <Plans />,
      },
      {
        path: links.checkout.plans,
        element: <Plans />,
      },
      {
        path: links.checkout.data,
        element: <Data />,
      },
      {
        path: links.checkout.payment,
        element: <Payment />,
      },
      {
        path: links.checkout.summary,
        element: <Summary />,
      },
    ],
    errorElement: <ErrorBoundary />,
  },

  {
    path: '*',
    element: <CheckoutLayout />,
    children: [
      {
        path: '*',
        index: true,
        element: <Plans />,
      },
    ],
  },
];
